import createStore from 'redux-zero';
import { applyMiddleware } from 'redux-zero/middleware';
import { connect } from 'redux-zero/devtools';

import { formInitialState } from './actions/formActions';
import { holderInitialState } from './actions/holderActions';
import { tablesInitialState } from './actions/tablesActions';

const initialState = {
  ui: {
    form: formInitialState,
    tables: tablesInitialState,
  },
  holder: holderInitialState,
};

const middlewares = connect ? applyMiddleware(connect(initialState)) : [];
const store = createStore(initialState, middlewares);

if (window.Cypress) {
  window.store = store;
}

export default store;
